import AllTFreeCourses from './AllTFreeCourses';
import './TFreeCourses.css';

const TFreeCourses = () =>{
    return(
        <div id="TFreeCourses">
            <div id="TFreeCoursesText">Trending Free Courses</div>
            <AllTFreeCourses />
        </div>
    )
}

export default TFreeCourses;